var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#222A2D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.47,12.12l1.42-1.61L5.56,10.42l-1.62,0.2l1.7,1.66c0.07,0.06,0.11,0.09,0.14,0.12l18.19,18.24 c0.63,0.63,1.31,0.95,2.03,0.95c0.72,0,1.4-0.32,2.03-0.95l18.2-18.25C46.31,12.32,46.38,12.23,46.47,12.12z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "48.9,40.64 48.98,11.36 34.19,26.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "3,40.53 17.77,26.03 3,11.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.33,9.38H5.66c-2.29,0-3.71,1.43-3.71,3.74v25.77c0,2.34,1.41,3.73,3.76,3.74h30.47l10.15-0.01 c2.29,0,3.72-1.41,3.72-3.68V13.07C50.05,10.79,48.62,9.38,46.33,9.38z M3,40.53V11.3l14.77,14.72L3,40.53z M26,31.6 c-0.72,0-1.4-0.32-2.03-0.95L5.78,12.41c-0.03-0.03-0.07-0.06-0.14-0.12l-1.7-1.66l1.62-0.2l42.33,0.09l-1.42,1.61 c-0.09,0.1-0.16,0.19-0.24,0.27l-18.2,18.25C27.4,31.28,26.72,31.6,26,31.6z M48.9,40.64L34.19,26.01l14.79-14.64L48.9,40.64z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.078dede284424eab7e81a00726563fb0.svg";
export { ForwardRef as ReactComponent };